<template>
  <div class="content-wrapper pt-2 h70" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="container-fluid h50">
      <div class=" mb-2 h-30">
        <div class="card-body">
          <!-- 内容开始 -->
          <div class="row height100">
            <!-- 新建建筑start -->
            <div class="col-lg-6  h-30" v-for="(i ,k) in buildList" :key="k" style="margin:0 auto">
              <div class="card-header bg-info2 text-white">建筑信息
              </div>
              <div class="card" v-if="building_attr_list.object_data!==undefined">
                <div class=" row mb-2">
                  <label class="col-sm-4  text-lr lh40"><i
                      class="fa fa-asterisk text-danger font10 ml-1"
                      aria-hidden="true"></i> 建筑名称：</label>
                  <div class="col-sm-7 flex1 lh35">
                    <el-input style="margin-bottom: 0px" size=""
                              v-model=" building_attr_list.object_data.name "
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>

                <div class=" row mb-2">
                  <label class="col-sm-4  text-lr lh40"><i
                      class="fa fa-asterisk text-danger font10 ml-1"
                      aria-hidden="true"></i> 建筑实体编码：</label>
                  <div class="col-sm-7 flex1 lh35">
                    <el-input style="margin-bottom: 0px" size=""
                              v-model=" building_attr_list.object_data.entity_code "
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <div class=" row mb-2">
                  <label class="col-sm-4  text-lr lh40">
                    <i
                        class="fa fa-asterisk text-danger font10 ml-1"
                        aria-hidden="true"></i>建筑外部编码：</label>
                  <div class="col-sm-7 flex1 lh35">
                    <el-input style="margin-bottom: 0px" size=""
                              v-model=" building_attr_list.object_data.bd_outside_id"
                              placeholder="请输入内容"></el-input>
                  </div>
                </div>
                <el-form class="form mt-3">
                  <div class=" " v-for="(val,index) in building_attr_list.object_data.static_attribute" :key="index">
                    <equip_attr_temp :Data="{'data':val,'obj':'building',
                                                          'attr':{'type':'1','objType':'building'}}">
                    </equip_attr_temp>
                  </div>
                  <div class=" " v-for="(val,index) in building_attr_list.object_data.special_attribute" :key="index">
                    <equip_attr_temp :Data="{'data':val,'obj':'building',
                                                          'attr':{'type':'2','objType':'building'}}">
                    </equip_attr_temp>
                  </div>
                  <!--                  <div>-->
                  <!--                    <equip_attr_temp v-if="flag"-->
                  <!--                                :Data="{'data':building_attr_list.object_data.static_attribute,'attr':'building',-->
                  <!--                               'index':k}"></equip_attr_temp>-->
                  <!--                  </div>-->
                </el-form>
              </div>
            </div>
            <!-- 新建建筑 end -->
          </div>
          <!-- 内容结束 -->
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer text-center">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="newly_or_edit">保 存</el-button>
    </div>
    <!----------------------------主要内容结束------------------------->

  </div>
</template>

<script>
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp";
import Vue from "vue";


export default {
  name: "yewuConfig",
  components: {
    equip_attr_temp
  },
  data() {
    return {
      project_id: this.$store.state.project_id,
      building_id: this.$route.query.building_id,
      platformid: this.$store.state.platform_Id,
      disabled_list: ['311001', '311002', '311003', '311005', '311006', '311007', '311008', '311009', '311010', '311011'],
      user_id: this.$store.state.user_id,
      role_id: this.$store.state.role_id,
      building_attr_list: [],
      project_attr_list: [],
      user_list: [],
      func_list: [],
      flag: true,
      check_flag: true,
      buildList: [{'index': 0}],
      after_user_list: [],
      type: this.$route.query.type,
      fullscreenLoading: false
    }
  },
  mounted() {
    console.log(this.building_id,'building_id')
    if (this.type === '0') {
      this.get_new_project_attr()//获取新建建筑表单
    } else {
      this.get_new_building_attr()
    }

  },
  methods: {


    cancel() {
      this.$store.commit('set_project_data', [])
      this.$store.commit('set_function_data', [])
      this.$store.commit('set_user_data', [])
      this.$router.back()
    },
    newly_or_edit() {
      if (this.building_id === '') {
        this.CreateNewProject()
      } else {
        this.editBuilding()
      }
    },
    //编辑建筑
    editBuilding() {
      // 必填验证
      let check = this.$check_data([this.$store.state.building_data.static_attribute])
      if (!check) {
        return
      }
      if (this.$store.state.building_data.name === '') {
        Vue.prototype.$message({
          message: '请填写建筑名称',
          type: 'error'
        });
        return
      }
      if (this.$store.state.building_data.entity_code === '') {
        Vue.prototype.$message({
          message: '请填写建筑实体编码',
          type: 'error'
        });
        return
      }
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.building_data
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$store.commit('set_building_data', [])
          // this.$router.push({path: 'OperationConfigIndex'})
          this.$router.back()
        }
        this.fullscreenLoading = false

      })
    },
    //保存新建建筑
    CreateNewProject() {
      console.log(this.$store.state.building_data.bd_outside_id)
      // 必填验证
      let check = this.$check_data([this.$store.state.building_data.static_attribute])
      if (!check) {
        return
      }
      if (this.$store.state.building_data.name === '') {
        Vue.prototype.$message({
          message: '请填写建筑名称',
          type: 'error'
        });
        return
      }
      if (this.$store.state.building_data.entity_code === '') {
        Vue.prototype.$message({
          message: '请填写建筑实体编码',
          type: 'error'
        });
        return
      }
      if (this.$store.state.building_data.bd_outside_id === null||this.$store.state.building_data.bd_outside_id ==='') {
        Vue.prototype.$message({
          message: '请填写建筑外部编码',
          type: 'error'
        });
        return
      }
      this.$store.state.building_data.project = this.project_id
      this.fullscreenLoading = true

      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.building_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$store.commit('set_building_data', [])
          // this.$router.push({path: 'OperationConfigIndex'})
          this.$router.back()
        }
        this.fullscreenLoading = false
      })
    },
    //获取新建建筑表单
    get_new_project_attr() {
      this.flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '12',
          }
        },
      }).then((response) => {
        this.building_attr_list = response.data.content
        this.$store.commit('set_building_data', this.building_attr_list.object_data)

        this.flag = true
      })
    },
    //获取建筑信息
    get_new_building_attr() {
      this.flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            "id": this.building_id,
          }
        },
      }).then((response) => {
        this.building_attr_list = response.data.content
        this.$store.commit('set_building_data', this.building_attr_list.object_data)
        this.flag = true
      })
    },
  }
}
</script>

<style scoped>
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-dropdown {
  display: block;
  position: relative;
  color: #606266;
  font-size: 14px;
}

/deep/ .el-select {
  display: block;
}

/deep/ .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
  padding-right: 15px;
  padding-left: 15px;
}

/deep/ .row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0;
  margin-left: 0;
}

/deep/ label {
  color: #575e61;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 400;
  margin-bottom: 10px;
}

/deep/ .test .el-input[data-v-21f637c4] {
  width: 100%;
  margin: 10px 0;
}

/deep/ .el-input__inner {

  height: 30px;
  line-height: 30px;

}

/deep/ .el-input__icon {
  height: 100%;
  width: 24px;
  text-align: center;
  transition: all .3s;
  line-height: 31px;
}
</style>
